import { render, staticRenderFns } from "./FichaModelo.vue?vue&type=template&id=1be850fa&scoped=true&"
import script from "./FichaModelo.vue?vue&type=script&lang=js&"
export * from "./FichaModelo.vue?vue&type=script&lang=js&"
import style0 from "./FichaModelo.vue?vue&type=style&index=0&id=1be850fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be850fa",
  null
  
)

export default component.exports